module.exports = __webpack_public_path__ + "media/images/lig/shirt-carousel/shirt-01-a4ae805cfd95ae6c84e293a3034fa5bf.jpg";